import React from 'react'
import { useTranslation } from 'react-i18next'

function SortWrapper({ children }) {
  const { t } = useTranslation()

  return (
    <div>
      <div className="label u-inline-block u-mr-50">
        {t('Sort by')}
      </div>
      {children}
    </div>
  )
}

export default SortWrapper
